import gql from 'graphql-tag'

export const userSubscription = gql`
	subscription($userId: ID!) {
		User(filter: {
			mutation_in: [UPDATED]
			updatedFields_contains_some: ["accountPaid", "birthDate", "birthPlace", "birthSigns", "birthTime", "lookup"]
			node: { id: $userId }
		}) {
			mutation
			updatedFields
			node {
				id
			}
		}
	}
`



// WEBPACK FOOTER //
// ./src/graphql/subscriptions/user.js